// extracted by mini-css-extract-plugin
export default {"fancyDiv":"J+bTJ___EmptyState-module__fancyDiv"};